import { Button, Modal } from 'antd';
import styled from 'styled-components';

import Icon from '@ant-design/icons';

export const Container = styled(Modal)(({ theme }) => ({
  width: '820rem !important',
  height: '615rem',
  color: theme.palette.white,

  '& .ant-modal-content': {
    backgroundColor: 'black',
    backgroundImage: `linear-gradient(180deg, ${theme.palette.graniteGray} 0%, ${theme.palette.black} 100%)`,
    backgroundPosition: '0% 0%',
    backgroundRepeat: 'no-repeat',
    backgroundOrigin: 'padding-box',
    boxShadow: `15rem 30rem 15rem ${theme.palette.black}29`,
    borderRadius: '5rem',
    width: '100%',
  },

  '& .ant-modal-close-icon': {
    color: theme.palette.white,
  },
}));

export const MainContent = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  width: '100%',
});

export const ModalTitle = styled.span(({ theme }) => ({
  display: 'block',
  fontSize: theme.typography.size36,
  fontFamily: theme.typography.family.playfairDisplay,
  color: theme.palette.white,
  textTransform: 'capitalize',
}));

export const ModalText = styled.span(({ theme }) => ({
  display: 'block',
  color: theme.palette.white,
  fontSize: theme.typography.size16,
  fontFamily: theme.typography.family.arial,
}));

export const CarouselContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  height: '366rem',
  marginTop: '10rem',
  position: 'relative',
  marginBottom: '10rem',
});

export const ImgContainer = styled.img({
  width: '640rem',
  height: '366rem',
  borderRadius: '10rem',
});

export const SelectButton = styled(Button)(({ theme }) => ({
  background: 'transparent',
  border: `1rem solid ${theme.palette.white}`,
  borderRadius: '20rem',
  height: '50rem',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',

  '&:hover': {
    color: `${theme.palette.black} !important`,
    background: `${theme.palette.white} !important`,
  },

  '& span': {
    fontSize: '20rem',
  },
}));

export const Icon3d = styled(Icon)({
  position: 'absolute',
  left: 'calc(50% - 75rem)',
});
